import React, { useMemo } from "react";
import styles from "./BookingsCountPopup.module.css";
import { useLocation, useHistory } from "react-router-dom";
import useApi from "../../../../custom_hooks/useApi";
import { getBookingsCountApi } from "../../../../services/newServices";
import { isAdmin } from "../../../../utills/utils";
import CustomButton from "../../../../components/custom/CustomButton";
import { routes } from "../../../../component_route/Index";
import { useTranslation } from "react-i18next";
import { Padding } from "@mui/icons-material";
import storageService from "../../../../services/storageServices";

export default function BookingsCountPopup() {
  const location = useLocation();
  const history = useHistory();

  const isHomePage = location.pathname === routes.home;

  const [
    bookingsCount,
    bookingsCountLoading,
    bookingsCountError,
    bookingsCountFetch,
    setBookingsCount,
  ] = useApi(
    {
      api: getBookingsCountApi,
      values: "New",
      trackingName: "getBookingsCountApi",
    },
    [location?.pathname]
  );

  const handlePayNow = () => {
    history.push(routes?.bookings);
  };

  const handleClose = () => {
    setBookingsCount(null);
  };

  const isAdminCheck = useMemo(() => isAdmin(), []);

  const { t } = useTranslation();

  return !isAdminCheck &&
    bookingsCount &&
    !bookingsCountLoading &&
    location?.pathname !== routes?.bookings &&
    isHomePage ? (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.close} onClick={handleClose}>
          X
        </div>
        <div className={styles.heading}>{t("new_booking_alert")}</div>
        <img
          src="https://ik.imagekit.io/hotelzifyprod/0140b4ef-d1f8-47d1-8daf-62154d11f5cc.png"
          style={{ height: "20vh" }}
        />
        <div className={styles.description} style={{ fontSize: "medium" }}>
          {t("youve_got")} {bookingsCount} {t("new_booking")}
        </div>
        <CustomButton
          onClick={handlePayNow}
          color="primary"
          buttonStyle={{ padding: "15px 50px", backgroundColor: "#e34f51" }}
        >
          <span style={{ fontWeight: "bold", fontSize: "medium" }}>
            {t("accept_now")}
          </span>
        </CustomButton>
      </div>
    </div>
  ) : null;
}
